export enum Role {
  SuperAdministrators = "superAdmin",
  Administrators = "administrators",
  Members = "members",
  RemoteAccess = "remoteAccess",

  LogReviewers = "secLogReviewers",

  MIOnlineAdministrators = "mioAdministrators",
  MIOViewers = "mioViewers",
  MIOAuthors = "mioAuthors",
  MIOManagers = "mioManagers",

  KMUsers = "kmUsers",
  KMManagers = "kmManagers",

  ASAdministrators = "asAdministrators",
  ASApprovers = "asApprovers",
  ASAuthors = "asAuthors",
  ASManagers = "asManagers",
  ASIT = "asIT",

  GINTAdministrators = "gintAdministrators",
  Procurement = "procurement",
  PurchaseWatchers = "purchaseWatchers",

  JOBOrderTHS = "joborderths",

  RDRfq = "rdRfq",
  RDRfqApprovers = "rdrqApprovers",

  AssetAdministrators = "assetAdministrators",
  AssetAuthors = "assetASAuthors",
  AssetViewers = "assetViewers",

  PurchaseAdministrators = "purchaseAdministrators",

  PCViewers = "purchaseViewers",
  PCAuthors = "purchaseAuthors",

  HumanResourcesAdministrators = "hrAdministrators",
  HumanResourcesAuthors = "hrAuthors",
  HumanResourcesViewers = "hrViewers",
}

// keep in sync with llce server: llce/models/permission/enum.go
